if (!customElements.get('variant-selects')) {
  class VariantSelectsFix extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange() {
      this.updateOptions();
      this.updateCurrentVariant();

      if (!this.currentVariant) return;

      this.updateURL();
      this.updateVariantInput();
      this.updatePriceSection();
    }

    updateOptions() {
      this.options = Array.from(
        this.querySelectorAll('select, input[type="radio"]:checked'),
        (element) => element.value
      );
    }

    updateCurrentVariant() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false);
      });
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);

      return this.variantData;
    }

    updateURL() {
      if (this.dataset.updateUrl === 'false') return;
      if (!this.currentVariant) return;

      window.history.replaceState(
        {},
        '',
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );

      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');

        if (input) {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    updatePriceSection() {
      const sectionId = this.dataset.section;
      const productUrl = this.dataset.url;

      if (!sectionId || !productUrl || !this.currentVariant) return;

      fetch(`${productUrl}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          const newPrice = html.querySelector(`#price-${sectionId}`);
          const currentPrice = document.querySelector(`#price-${sectionId}`);

          if (newPrice && currentPrice) {
            currentPrice.innerHTML = newPrice.innerHTML;
          }

          const newSku = html.querySelector(`#Sku-${sectionId}`);
          const currentSku = document.querySelector(`#Sku-${sectionId}`);

          if (newSku && currentSku) {
            currentSku.innerHTML = newSku.innerHTML;
            currentSku.className = newSku.className;
          }

          const newInventory = html.querySelector(`#Inventory-${sectionId}`);
          const currentInventory = document.querySelector(`#Inventory-${sectionId}`);

          if (newInventory && currentInventory) {
            currentInventory.innerHTML = newInventory.innerHTML;
            currentInventory.className = newInventory.className;
          }
        })
        .catch((error) => {
          console.log('Error actualizando precio de variante:', error);
        });
    }
  }

  customElements.define('variant-selects', VariantSelectsFix);
}